import { createSelector } from 'reselect'
import { RootState } from '../index'

export const selectedOrganization = createSelector(
  (state: RootState) => state.dealership.dealership,
  (dealership) => dealership?.organization_id,
)
